import { messages } from './src/widgets/i18n/locales/en.ts';
window.__plpLocales ??= {};
window.__plpLocales['en'] = messages;
